import React from 'react'
import { Stack } from '~/components/_layouts'
import { Typography, Button } from '~/components/_atoms'
import { useTranslation } from '~/hooks/useTranslation'
import YnsIcon from '~/components/icons/YnsIcon'
import { useIsMobile } from '~/hooks/useMediaQuery'

const ResourceCard = () => {
  const { t } = useTranslation('live_chat')
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <Stack spacing={4}>
        <div className="flex max-w-screen-lg flex-col items-center gap-3 rounded-2xl bg-intoo-blue-medium-100 p-6 shadow-sm">
          <div className="flex items-center gap-2">
            <YnsIcon
              name="Article"
              className="h-8 w-8 text-intoo-blue-medium-700"
            />
            <Typography variant="h6" component="h3" color="primary">
              {t('learn_more_article.title')}
            </Typography>
          </div>
          <div className="h-48 w-48 shrink-0">
            <img
              src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/coach_services/Article_ways_to_utilize-chat.jpg"
              alt=""
              className="h-full w-full rounded-2xl object-cover"
            />
          </div>
          <Typography variant="body2" color="primary">
            {t('learn_more_article.description')}
          </Typography>
          <Button
            href="/coach_services/article/ways-to-utilize-coach-chat"
            color="primary"
            variant="solid"
            className="self-start"
          >
            {t('read_article')}
            {/* CTS-9289: sr-only article title on “Read article” CTA */}
            <span className="sr-only">, {t('learn_more_article.title')}</span>
          </Button>
        </div>
      </Stack>
    )
  }

  return (
    <Stack spacing={4}>
      <div className="flex max-w-screen-lg items-center gap-6 rounded-2xl bg-intoo-blue-medium-100 shadow-sm">
        <div className="flex flex-1 items-start gap-2 p-5">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <YnsIcon
                name="Article"
                className="h-8 w-8 text-intoo-blue-medium-700"
              />
              <Typography variant="h6" component="h3" color="primary">
                {t('learn_more_article.title')}
              </Typography>
            </div>
            <Typography variant="body2" color="primary">
              {t('learn_more_article.description')}
            </Typography>
            {/* CTS-9289: sr-only article title on “Read article” CTA (same visible text, distinct destination) */}
            <Button
              href="/coach_services/article/ways-to-utilize-coach-chat"
              color="primary"
              variant="solid"
              className="self-start"
            >
              {t('read_article')}
              <span className="sr-only">, {t('learn_more_article.title')}</span>
            </Button>
          </div>
        </div>
        <div className="w-[13rem] shrink-0">
          <img
            src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/coach_services/Article_ways_to_utilize-chat.jpg"
            alt=""
            className="h-full w-full rounded-r-lg object-cover"
          />
        </div>
      </div>
    </Stack>
  )
}

export default ResourceCard
